<div class="pv-input">
	@if (label) {
		<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required && isRequired">
			{{ label }}
		</ic-label>
	}
	<div class="border" [class.suffix]="suffix" [class.wizard]="openWizard | hasObservers">
		@if (isPending || icon) {
			<i aria-hidden="true" [class]="isPending ? pendingIcon : icon" [class.disabled]="disabled"> </i>
		}

		@if (!icon && indicator) {
			<i aria-hidden="true" class="indicator" [class.disabled]="disabled"> {{ indicator }} </i>
		}

		<!-- Note: The mask input does not currently support sending the raw value without the mask in the form value. Therefore,
    if you want to send the raw value, you will need to modify the masked value input before sending the data. This is a
    known issue and we are waiting for a fix from the ngx-mask and Angular. -->

		<!-- https://github.com/JsDaddy/ngx-mask/issues/896 -->

		<!-- An example in our codebase is when masking and saving a SSN number.
    File: 'management.component.ts' in 'hq'
    Function: finish() -->

		@if (mask) {
			<input
				[attr.autocapitalize]="autocapitalize"
				[attr.autocomplete]="autocomplete"
				[attr.disabled]="disabled || null"
				[attr.maxlength]="maxLength"
				[attr.minlength]="minLength"
				[class]="inputClass"
				[dateTime]="dateTime"
				[placeholder]="placeholder"
				[ssn]="ssn"
				[type]="type"
				[value]="value | mask: mask"
				(blur)="onTouched()"
				(input)="onChange($any($event).target.value)"
			/>
		} @else {
			<input
				[attr.autocapitalize]="autocapitalize"
				[attr.autocomplete]="autocomplete"
				[attr.disabled]="disabled || null"
				[attr.maxlength]="maxLength"
				[attr.minlength]="minLength"
				[class]="inputClass"
				[dateTime]="dateTime"
				[placeholder]="placeholder"
				[ssn]="ssn"
				[type]="type"
				[value]="value"
				(blur)="onTouched()"
				(input)="onChange($any($event).target.value)"
			/>
		}

		<span> {{ suffix }} </span>

		@if ((pasteValue | hasObservers) && !disabled) {
			<i
				class="wizard-icon fa fa-copy"
				data-test="copy-button"
				matTooltipClass="pv-tooltip"
				matTooltipPosition="below"
				[matTooltip]="pasteTooltip"
				[matTooltipShowDelay]="300"
				(click)="pasteValue.emit()"
			>
			</i>
		}

		@if ((openWizard | hasObservers) && !disabled) {
			<i
				matTooltipClass="pv-tooltip"
				matTooltipPosition="below"
				[matTooltip]="wizardTooltip"
				[matTooltipShowDelay]="300"
				[ngClass]="['wizard-icon', wizardIcon]"
				(click)="openWizard.emit()"
			>
			</i>
		}
	</div>
	<ng-content select=".errors" />
</div>
